import { render, staticRenderFns } from "./TheApprovalOrdersWrapper.vue?vue&type=template&id=5349a2e7&scoped=true"
import script from "./TheApprovalOrdersWrapper.vue?vue&type=script&lang=js"
export * from "./TheApprovalOrdersWrapper.vue?vue&type=script&lang=js"
import style0 from "./TheApprovalOrdersWrapper.vue?vue&type=style&index=0&id=5349a2e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349a2e7",
  null
  
)

export default component.exports